import { NavigationProperty, PropretyAttributes } from "../../decorators/EntityDecorators";
import { Translation } from "./navigation-entities/Translation.model";
import { GenericEntityBase, KeyType } from "../../_models/GenericEntityBase";
import { IEntityMetaData, IPropretyAttribute } from "../../_models/IEntityMetaData";

export class QuizResponse extends GenericEntityBase<number> {

    @PropretyAttributes({ attributes: [IPropretyAttribute.KeyProperty, IPropretyAttribute.Readonly] })
    id: number = GenericEntityBase.GetDefaultId(KeyType.number);

    @PropretyAttributes({ attributes: [IPropretyAttribute.Required] })
    fK_Quiz!: number;

    isRightResponse: boolean = false;

    numero?: number;

    description?: string;

    @NavigationProperty({ TargetType: Translation })
    translations?: Translation[];

    GetType(): IEntityMetaData {
        return QuizResponse.getMetaData();
    }
}